import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";

import { getSessionDownloadLink } from "@/Services/TherapyApi/ClinicalHistory";

import useCustomerStore from "@/Modules/Customers/Store";

import { log } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

async function getSessionDownloadLinkAH(paymentReceiptUuid: string) {
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return undefined;

  clinicalHistoryStore.isLoadingSession = true;

  try {
    const { signed_url } = await getSessionDownloadLink(
      customerStore.getCurrentCustomer.id,
      paymentReceiptUuid
    );

    clinicalHistoryStore.sessionSelectedLink = signed_url;
  } catch (error) {
    log(error);
  } finally {
    clinicalHistoryStore.isLoadingSession = false;
  }
}

export default getSessionDownloadLinkAH;
